/**

 * Hiérarchie panel staff (auth_role.id) :

 * - CM (1), Admin (2), Modo (3), GR (4) : scénarios CTA (création / édition)

 * - Créateur de contenu (5) : streamers / youtubeurs — aucun accès panel

 * - Joueurs (6) : pas de panel (premium = avantage jeu uniquement)

 *

 * Validation « actif » : référent scénario (auth_referent), pas le créateur du brouillon.

 */



/** Membre équipe staff autorisé à voir le panel (rôles 1 à 4 uniquement). */

export function isPanelTeamMember(roleId: number): boolean {

  return roleId >= 1 && roleId <= 16;

}



/** Équipe scénarios CTA (identique à l’équipe panel, rôles 1 à 4). */

export function isScenarioTeamRole(roleId: number): boolean {

  return isPanelTeamMember(roleId);

}



/** Rôle GR — Groupe de réflexion (pilote scénarios). */

export function isGrRole(roleId: number): boolean {

  return roleId === 15;

}



export function canPanelCm(roleId: number): boolean {

  return roleId === 1;

}



export function canPanelAdminTier(roleId: number): boolean {

  return roleId >= 1 && roleId <= 7;

}



export function canPanelModoTier(roleId: number): boolean {

  return roleId === 1 || roleId === 4 || (roleId >= 8 && roleId <= 11);

}



/** Modération, signalements, fiches joueurs (surveillance). */

export function canPanelModeratePlayers(roleId: number): boolean {

  return roleId >= 1 && roleId <= 11;

}



/** Premium, économie, possessions avancées — admin + CM. */

export function canPanelManagePremium(roleId: number): boolean {

  return canPanelAdminTier(roleId);

}



/** CTA, création / gestion scénarios, catégories mission — équipe 1 à 4 (GR inclus). */

export function canPanelManageInterventions(roleId: number): boolean {

  return isScenarioTeamRole(roleId);

}



export function canPanelViewInterventionsCta(roleId: number): boolean {

  return canPanelManageInterventions(roleId);

}



/** Config, maintenance, sauvegardes, rôles individuels. */

export function canPanelSystemCm(roleId: number): boolean {

  return roleId === 1;

}


